import PopUp from '@/common/components/PopUp';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import styled from 'styled-components';
import CameraIcon from './images/camera.svg';
import ExampleImage from './images/photo-conversation.png';
import GradientButton from '@/common/components/custom/buttons/GradientButton';
import { useNavigate } from 'react-router-dom';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	padding-top: 10px;
	padding-bottom: 20px;
	gap: 10px;
	max-width: 350px;
`;

const TopWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	gap: 10px;
`;

const Camera = styled.img`
	width: 24px;
	height: 24px;
`;

const Title = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 28px */
`;

const Text = styled.div`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 14px */
	width: 80%;
`;

const NewBadge = styled.div`
	color: #fff;
	font-family: 'Work Sans';
	font-size: 15px;
	font-style: normal;
	font-weight: 300;
	line-height: 140%; /* 22.4px */
	border-radius: 21px;
	background: #32951b;
	width: fit-content;
	padding: 0px 10px;
`;

type Props = { onClose: () => void };

function PhotoConversationInfoPopup({ onClose }: Props) {
	const langData = useLanguageData('home.photoConversation');
	const navigate = useNavigate();

	const handleClick = () => {
		onClose();
		navigate('/learn/chat');
	};

	return (
		<PopUp setClose={onClose}>
			<NewBadge>{langData.new}</NewBadge>
			<Wrapper>
				<TopWrapper>
					<Title>{langData.photoConversationMode}</Title>
					<Camera src={CameraIcon} alt='camera' />
				</TopWrapper>
				<Text>{langData.goToChatTakeAPhoto}</Text>
				<img src={ExampleImage} alt='example' />
				<GradientButton
					onClick={handleClick}
					title={langData.check}
					style={{ width: '180px', height: '40px', fontSize: '15px' }}
				/>
			</Wrapper>
		</PopUp>
	);
}

export default PhotoConversationInfoPopup;
